import { copyObject } from '@shared/zb-object-helper/object-helper';
import moment, { Moment } from 'moment';
/**
 * Provides a formatted day of the week.
 */
export class PlannerWeekDay {
  /**
   * The abbreviated month.
   */
  month: string = undefined;
  /**
   * The calendar day.
   */
  date: string = undefined;
  /**
   * The abbreviated day of the week.
   */
  dayOfWeek: string = undefined;
  /**
   * Whether this weekday is today for the user.
   */
  isToday: boolean = undefined;
  thumbnailBackground: string = undefined;
  thumbnailSideBorder: string = undefined;

  private static createDayOfWeek(beginningDate: Moment, days: number): PlannerWeekDay {
    const date = moment(beginningDate).add(days, 'd');
    const plannerWeekDay = {
      month: date.format('MMM'),
      date: date.format('D'),
      dayOfWeek: date.format('ddd'),
      isToday: date.isSame(moment(), 'day'),
      thumbnailBackground: 'e02619',
      thumbnailSideBorder: '000',
    };
    return copyObject(plannerWeekDay, PlannerWeekDay);
  }

  static generateWeek(beginningDate: Moment): PlannerWeekDay[] {
    return [
      this.createDayOfWeek(beginningDate, 1),
      this.createDayOfWeek(beginningDate, 2),
      this.createDayOfWeek(beginningDate, 3),
      this.createDayOfWeek(beginningDate, 4),
      null,
      this.createDayOfWeek(beginningDate, 5),
    ];
  }
}
